import { useEffect, useState } from 'react';

import { canSkipCheckout } from '../../../../../../util/account';

/**
 * Photo search immediate checkout hook.
 *
 * Checks whether the Account meets the criteria to join the Albums
 * or AlbumFolders and initiates checkout (ie joining) immediately
 * skipping the photo search checkout UI.
 *
 * @param {Object} options The options.
 * @param {Object} options.account The Account object.
 * @param {Function} options.onCheckout The checkout method.
 * @returns {boolean} Whether we are skipping the checkout UI.
 */
const usePhotoSearchImmediateCheckout = ({ account, onCheckout }) => {
  const [checkingOut, setCheckingOut] = useState(false);

  useEffect(() => {
    if (canSkipCheckout(account)) {
      setCheckingOut(true);
      onCheckout();
    }
  }, [account]);

  return checkingOut;
};

export default usePhotoSearchImmediateCheckout;
